// extracted by mini-css-extract-plugin
var _1 = "AddAttachmentMenuItem-module__input--ZVV1H";
export { _1 as "input" }
